<label
    class="toggle"
    [class.disabled]="cannotInvalidate()"
    [matTooltip]="cannotInvalidate() ? ('cannotInvalidateInterventionDone' | transloco) : null">
    <input
        type="checkbox"
        [checked]="currentValidity() === ToggleValidationEnum.VALID"
        [disabled]="cannotInvalidate()"
        (change)="toggleValidation()" />

    <div
        class="slider"
        [ngClass]="{
            valid: currentValidity() === ToggleValidationEnum.VALID,
            invalid: currentValidity() === ToggleValidationEnum.INVALID,
            'to-validate': currentValidity() === ToggleValidationEnum.TO_VALIDATE,
        }">
        <span class="icon">
            <fa-icon
                class="icon"
                size="sm"
                [icon]="icon" />
        </span>
    </div>
</label>
